import { createStore, reconcile } from 'solid-js/store';
import { createEffect, on, batch } from 'solid-js';
import { schemaValidator, eidos_schema } from 'schemas';

const specValidate = schemaValidator.compile(eidos_schema);

const [spec, setSpec] = createStore({
  id: '_undefined',
  name: '',
  modalNodes: [],
  root: { id: null, nodeType: null, children: [] },
  data: [],
  transforms: [],
});

const specUpdate = (newSpec) => {
  setSpec(reconcile(newSpec));
};

const specPatch = (patch) => {
  batch(() => {
    patch.map((p) => {
      let path = p.path.split('/').slice(1);
      const p1 = path[path.length - 1];
      const arrayOp = p1 === '-' || Number(p1) >= 0;
      let state = spec;
      path = path.slice(0, path.length - !!arrayOp);
      if (arrayOp) {
        if (p.op == 'remove') {
          setSpec(...path, (s) => s.filter((_, i) => i !== Number(p1)));
        } else if (p1 === '-') {
          setSpec(...path, (s) => [...s, p.value]);
        } else {
          setSpec(...path, Number(p1), p.value);
        }
      } else {
        if (p.op === 'remove') {
          setSpec(...path, undefined);
        } else {
          setSpec(...path, reconcile(p.value));
        }
      }
    });
  });
};

function specTrack(store) {
  for (const k in store) {
    const value = store[k];
    if (typeof value === 'object') {
      specTrack(value);
    }
  }
}

createEffect(
  on(
    () => specTrack(spec),
    () => {
      if (spec.id === '_undefined') return;
      specValidate(spec) ||
        specValidate.errors.map((error) =>
          console.log(
            `Spec does not validate: ${error.instancePath} -> ${error.message} (${JSON.stringify(error.params)})`,
          ),
        );
    },
  ),
);

export { spec, specPatch, specUpdate, specTrack };
